// extracted by mini-css-extract-plugin
module.exports = {"contentBox":"jA","contentFrame":"jB","buttonGroup":"jC","button":"jD","header":"jE","text":"jF","contentImage":"jG"};